export const CONFIG_NAV_DEV = {
  main: [
    { name: 'mission', root: '/mission', lc: false },
    { name: 'science-innovation', root: '/science-innovation', lc: false },
    { name: 'collaboration', root: '/collaboration', lc: false },
    { name: 'community', root: '/community', lc: false },
    { name: 'environment', root: '/environment', lc: false },
  ],
  utility: [
    { name: 'About', root: '/about' },
    { name: 'Business', root: '/business' },
    { name: 'Organizations', root: '/orgs' },
  ],
};

export const CONFIG_NAV_STAGE = {
  main: [
    {
      name: 'mission',
      root: 'https://d1j81xwwsxm6cu.cloudfront.net',
      lc: false,
    },
    {
      name: 'science-innovation',
      root: 'https://d1c1ztszlu4ee2.cloudfront.net',
      lc: false,
    },
    {
      name: 'collaboration',
      root: 'https://d249y4weebjl7j.cloudfront.net',
      lc: false,
    },
    {
      name: 'community',
      root: 'https://dseb99um4oag2.cloudfront.net',
      lc: false,
    },
    {
      name: 'environment',
      root: 'https://d9cnux01h2yl4.cloudfront.net',
      lc: false,
    },
  ],
  utility: [
    { name: 'About', root: 'https://d1x2881jwu4kr3.cloudfront.net' },
    { name: 'Business', root: 'https://d2gsjhu5uwsy3v.cloudfront.net' },
    { name: 'Organizations', root: 'https://d2fx3h9u4exi61.cloudfront.net' },
  ],
};

export const CONFIG_NAV_PROD = {
  main: [
    {
      name: 'mission',
      root: 'https://www.lanl.gov/about/mission',
      lc: false,
    },
    {
      name: 'science-innovation',
      root: 'https://www.lanl.gov/science-engineering',
      lc: false,
    },
    {
      name: 'collaboration',
      root: 'https://www.lanl.gov/engage/collaboration',
      lc: false,
    },
    {
      name: 'community',
      root: 'https://www.lanl.gov/engage/community',
      lc: false,
    },
    {
      name: 'environment',
      root: 'https://www.lanl.gov/engage/environment',
      lc: false,
    },
  ],
  utility: [
    { name: 'About', root: 'https://www.lanl.gov/about' },
    { name: 'Business', root: 'https://www.lanl.gov/engage/business' },
    {
      name: 'Organizations',
      root: 'https://www.lanl.gov/engage/organizations',
    },
  ],
};
